import { find, get } from 'lodash';
import { TypeSupportArticle, TypeSupportCategory } from 'types/contentful/clinical';

interface ProcessedData {
  [categoryName: string]: {
    articlesWithoutSubCategory: TypeSupportArticle[];
    articlesWithSubCategory: TypeSupportArticle[];
  };
}

/**
 *dev-note(gian): This function is used to normalize the articles and categories data
 * so that we can easily access the articles for a given category
 */

export function normalizeArticles(articles: TypeSupportArticle[], categories: TypeSupportCategory[]): ProcessedData {
  const result: ProcessedData = {};

  const getCategory = (article: TypeSupportArticle) => {
    // get the category name from the article that is on categories array
    const category = find(categories, (cat: TypeSupportCategory) => {
      const articleCategory = get(article, 'fields.supportCategory[0].sys.id', '');
      return cat.sys.id === articleCategory;
    });

    return get(category, 'fields.categoryTitle', '').toLowerCase();
  };

  const isSubCategoryPresent = (article: TypeSupportArticle) => {
    return !!article.fields.supportSubCategories;
  };

  const allCategories = Array.from(new Set(categories.map(category => category.fields.categoryTitle.toLowerCase())));
  allCategories.forEach(category => {
    result[category] = {
      articlesWithoutSubCategory: [],
      articlesWithSubCategory: [],
    };
  });

  articles.forEach(article => {
    const category = getCategory(article);
    const isSubCategory = isSubCategoryPresent(article);

    const targetArray = isSubCategory
      ? result[category].articlesWithSubCategory
      : result[category].articlesWithoutSubCategory;

    targetArray.push(article as TypeSupportArticle & TypeSupportCategory);

    // edge-case: the article is in multiple categories but it has no subcategories
    // in this case, we add to the respective categories but in the array of articles without subcategories
    if (isSubCategory) {
      const otherCategories = article?.fields?.supportCategory
        ?.map(cat => cat.fields.categoryTitle.toLowerCase())
        .filter(cat => cat !== category);

      otherCategories?.forEach(cat => result[cat].articlesWithoutSubCategory.push(article));
    }
  });

  return result;
}
